import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';

import moment from 'moment';
import request from '../../helpers/request';
import SimplePage from '../common/SimplePage';
import itemConfig from './config/itemConfig';
import setViewTitle from '../../helpers/setViewTitle';
import auth0 from '../../helpers/auth0';
import debounce from '../../helpers/debounce';
import storagelocationConfig from '../storagelocations/config/storagelocationConfig';
import StorageLocationAutoComplete from '../common/AutocompleteText';
import Modal from '../common/Modal';

const $ = window.$;

var Items = createReactClass({
  getInitialState() {

    var accessToken = auth0.getAccessToken();

    let queryString = '?api_key=' + accessToken;
    // var currentStockReportUrl = itemConfig.currentStockReportDownloadUrl + queryString;
    var itemWithdrawalsReportUrl = itemConfig.withdrawalReportDownloadUrl + queryString;

    return {
      selectedStockReportDate: false,
      items: [],
      actions: [
        {title: 'Neuer Artikel', to: '/items/new', claim: 'items:write' },
      ],
      reports: [
        {title: 'Lagerbestand', to: '#', staticContent: false, onClick: this.showCurrentStockModal},
        {title: 'Abfassungen', to: itemWithdrawalsReportUrl, staticContent: true}
      ],
      itemNameFilter: null,
      storageLocationIdFilter: null
    };
  },

  componentWillMount() {
    setViewTitle('Lagerübersicht');
    this.debouncedReloadData = debounce(this.reloadData, 300);
  },

  componentDidMount() {

    $('#currentStockModelDate').datepicker({
      dateFormat: 'dd.mm.yy',
      prevText: '<i class="fa fa-chevron-left"></i>',
      nextText: '<i class="fa fa-chevron-right"></i>'
    });

    $('#currentStockModelDate').change(e => {
      this.setState({selectedStockReportDate: e.target.value})
    });

    this.reloadData();
  },

  showCurrentStockModal() {
    const selectedStockReportDate = moment().format('DD.MM.YYYY');
    this.setState({ selectedStockReportDate }, () => {
      $('#currentStockModelDate').val(selectedStockReportDate);
      this.currentStockModal.show();
    });
  },

  downloadCurrentStockReport() {
    const selectedDateMoment = moment(this.state.selectedStockReportDate, 'DD.MM.YYYY');

    const date = selectedDateMoment.isValid()
      ? selectedDateMoment.set({hour: 12}).utc().format()
      : moment().utc().format();
    
      var accessToken = auth0.getAccessToken();

      let queryString = `?date=${date}&api_key=${accessToken}`;
      const downloadUrl = itemConfig.currentStockReportDownloadUrl + queryString;

      window.location = downloadUrl;
  },

  reloadData() {
    request.get({
      url: itemConfig.apiUrl,
      data: this.createFilterParams(),
      success: data => {
        if (this.isMounted()) {
          this.setState({
            items: data
          });
        }
      }
    });
  },

  createFilterParams() {
    return {
      term: this.state.itemNameFilter,
      storageLocationId: this.state.storageLocationIdFilter
    };
  },

  applyStorageLocationFilter(storageLocation) {
    this.setState({storageLocationIdFilter: storageLocation.id}, () => this.reloadData());
  },

  applyFilter(e) {
    var propName = e.target.name;
    var value = e.target.value;

    var newState = {};
    newState[propName] = value;

    this.setState(newState, () => this.debouncedReloadData());
  },

  render() {

    var itemsList = this.state.items.map(item =>
      <tr key={item.id}>
        <td><Link to={`/items/${item.id}`}>{item.name}</Link></td>
        <td>{item.defaultStorageLocationName}</td>
        <td>{item.defaultStorageBinName}</td>
        <td>{item.totalStockQuantity}</td>
        <td>{item.orderedQuantity}</td>
        <td>{item.suggestedQuantity}</td>
        <td>{item.lowStockLimit}</td>
      </tr>
    );

    return (
      <SimplePage title="Lagerübersicht" icon="cubes" actions={this.state.actions} reports={this.state.reports}>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Lagerort</th>
                <th>Lagerplatz</th>
                <th>Im Lager</th>
                <th>Bestellt</th>
                <th>Vorgeschlagen</th>
                <th>Mindestmenge</th>
              </tr>
              <tr>
                <th>
                  <input type="text" name="itemNameFilter" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th>
                  <StorageLocationAutoComplete
                    ref={c => this.storageLocationFilter = c}
                    dataUrl={storagelocationConfig.fastSearchUrl}
                    onSelect={this.applyStorageLocationFilter}
                    searchPlaceholder="Filter"
                    idProp="id"
                    displayProp="name"
                    noMatchesText="Kein Ergebnis"
                    searchInProgressText="Suche..."
                  />
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
                {itemsList}
            </tbody>
          </table>
        </div>
        <Modal
          ref={c => this.currentStockModal = c}
          title="Lagerbestand"
          rejectButtonText="Cancel"
          confirmButtonText="Download"
          onConfirm={this.downloadCurrentStockReport}
          confirmStyle='success'
          content={<div>
            <input
              id="currentStockModelDate"
              name="currentStockModelDate"
              type="text"
              className="form-control"
              placeholder="Datum..."
            />
          </div>}
        />
      </SimplePage>
    );
  }
});

export default Items;



// WEBPACK FOOTER //
// ./src/components/items/Items.js